import styled from 'styled-components';

export const UiUploadButtonLabel = styled.div`
	margin-left: 0.5rem;
`;
